import { TranslateLoader, TranslateService, TranslateModule } from '@ngx-translate/core';
import { ABTestingModule, ABTestingSelectionStrategy, RandomWeightedStrategy } from './abtesting.service';
import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

//Material
import {MatAutocompleteModule} from '@angular/material/autocomplete';
import {MatToolbarModule} from '@angular/material/toolbar';
import { MatIconModule } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { MatInputModule } from '@angular/material/input';
import { MatButtonModule } from '@angular/material/button';
import { MatListModule } from '@angular/material/list';
import {MatTooltipModule} from '@angular/material/tooltip';
import { MatExpansionModule } from '@angular/material/expansion';
import { InternalLinks } from './components/internal-links/internal-links.component';
import { PricePromotionComponent } from './components/price-promotion/price-promotion';
import { LoadingComponent } from './components/loading/loading.component';
import { ProgressiveImage } from './components/progressive-image/progressive-image.component';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { CustomSelectComponent } from './components/custom-select/custom-select.component';
import { HighLightPipe } from './pipes/highlightpipe.pipe';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { StickyDirective } from './directives/sticky-element';


const MODULES = [
    CommonModule,
    TranslateModule,
    ABTestingModule,    
    RouterModule,
    FormsModule,    
    ReactiveFormsModule,
    MatAutocompleteModule,
    MatToolbarModule,
    MatIconModule,
    MatCardModule,
    MatInputModule,
    MatButtonModule,
    MatDatepickerModule,
    MatListModule,
    MatTooltipModule,
    MatExpansionModule,
    LazyLoadImageModule
  ];
  
  const PIPES = [
    // put pipes here
    HighLightPipe
  ];
  
  const COMPONENTS = [
    InternalLinks,
    PricePromotionComponent,
    LoadingComponent,
    ProgressiveImage,
    CustomSelectComponent,
    StickyDirective
  ];
  
  const PROVIDERS = [
  ]
  
  @NgModule({
    imports: [        
      ...MODULES,      
      ABTestingModule.withConfig({
        strategy: { provide: ABTestingSelectionStrategy, useClass: RandomWeightedStrategy },
        experiments: [
          /*{ I left this code commented to remember how a experiment is done.
            experimentName:'ANGULAR6',
            versions: {A:0, B:100}
          }*/
        ],
      }),
    ],
    declarations: [
      ...PIPES,
      ...PROVIDERS,
      ...COMPONENTS
    ],
    exports: [
      ...MODULES,
      ...PIPES,
      ...COMPONENTS      
    ]
})
  export class SharedModule { }